@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.without-rate {
  font-size: 14px;
  color: @fulfillment-planner--rate-amount--text-color;
}

.with-rate {
  font-size: 14px;
  color: @fulfillment-planner--rate-amount--text-color;
}
